import { HugeiconsIcon } from "@hugeicons/react";
import { Image02Icon } from "@hugeicons-pro/core-stroke-rounded";

export const UnitCoverPhoto = ({
  url,
  alt
}: {
  url?: string | null;
  alt: string;
}) => (
  <div className="relative aspect-[2/1] w-full overflow-hidden bg-alpha-40">
    {url ? (
      <img
        src={url}
        alt={alt}
        loading="lazy"
        decoding="async"
        className="h-full w-full object-cover"
      />
    ) : (
      <div className="flex h-full w-full items-center justify-center">
        <HugeiconsIcon
          size={32}
          icon={Image02Icon}
          className="text-content-200"
        />
      </div>
    )}
  </div>
);
